"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * {@docCategory ScrollablePane}
 */
exports.ScrollbarVisibility = {
    auto: 'auto',
    always: 'always'
};
//# sourceMappingURL=ScrollablePane.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ScrollablePane/ScrollablePane.types.js
// module id = 1140
// module chunks = 0